import { apiClient } from './api'

export interface FormVersion {
  formVersionId: string
  formName: string
  formSchema: string
  uiSchema: string | null
  validationConfig: string | null
  status: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED'
  description: string | null
  createdAt: string
  createdBy: string
  updatedAt: string
  updatedBy: string
  version: number
}

export interface CreateFormVersionRequest {
  formName: string
  formSchema: string
  uiSchema?: string
  validationConfig?: string
  description?: string
}

export interface UpdateFormVersionRequest {
  formName: string
  formSchema: string
  uiSchema?: string
  validationConfig?: string
  description?: string
}

export interface LintRequest {
  formSchema: string
  uiSchema?: string
  validationConfig?: string
}

export interface LintResult {
  pass: boolean
  warnings: string[]
  errors: string[]
}

export class FormVersionService {
  static async getAll(params?: {
    q?: string
    status?: string
  }): Promise<FormVersion[]> {
    const queryParams = new URLSearchParams()
    if (params?.q) queryParams.append('q', params.q)
    if (params?.status) queryParams.append('status', params.status)

    const queryString = queryParams.toString()
    const url = queryString ? `/api/form-versions?${queryString}` : '/api/form-versions'
    return apiClient.get<FormVersion[]>(url)
  }

  static async getById(id: string): Promise<FormVersion> {
    return apiClient.get<FormVersion>(`/api/form-versions/${id}`)
  }

  static async create(request: CreateFormVersionRequest): Promise<FormVersion> {
    return apiClient.post<FormVersion>('/api/form-versions', request)
  }

  static async update(id: string, request: UpdateFormVersionRequest): Promise<FormVersion> {
    return apiClient.put<FormVersion>(`/api/form-versions/${id}`, request)
  }

  static async lint(request: LintRequest): Promise<LintResult> {
    return apiClient.post<LintResult>('/api/form-versions/lint', request)
  }

  static async publish(id: string): Promise<{ status: string }> {
    return apiClient.post<{ status: string }>(`/api/form-versions/${id}/publish`)
  }

  static async archive(id: string): Promise<{ status: string }> {
    return apiClient.post<{ status: string }>(`/api/form-versions/${id}/archive`)
  }

  static async unarchive(id: string): Promise<{ status: string }> {
    return apiClient.post<{ status: string }>(`/api/form-versions/${id}/unarchive`)
  }

  static async duplicate(id: string): Promise<FormVersion> {
    return apiClient.post<FormVersion>(`/api/form-versions/${id}/duplicate`)
  }
}
